
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book-testing/privateschool",
      function () {
        return require("private-next-pages/book-testing/privateschool.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/book-testing/privateschool"])
      });
    }
  